import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const assessmentPermitTypesFilterMixin = {
  data() {
    return {
      filteredAssessmentPermitTypes: [],
    };
  },
  watch: {
    assessmentPermitTypes: {
      immediate: true,
      handler() {
        this.filteredAssessmentPermitTypes = this.assessmentPermitTypes;
      },
    },
  },
  methods: {
    assessmentPermitTypesFilterMethod(query) {
      this.filteredAssessmentPermitTypes = searchWithDiacritics(query, this.assessmentPermitTypes, ['name']);
    },
    handleAssessmentPermitTypesVisibleChange() {
      setTimeout(() => {
        this.filteredAssessmentPermitTypes = this.assessmentPermitTypes;
      }, 50);
    },
  },
};
